import React from 'react';
import { Hero } from './components/Hero';
import { PainPoints } from './components/PainPoints';
import { Solution } from './components/Solution';
import { Tomos } from './components/Tomos';
import { Bonos } from './components/Bonos';
import { Authorities } from './components/Authorities';
import { Guarantee } from './components/Guarantee';
import { Pricing } from './components/Pricing';
import { Faq } from './components/Faq';
import { FinalCta } from './components/FinalCta';
import { SiteFooter } from './components/SiteFooter';
import { useMetaPixel } from './hooks/useMetaPixel';
export function App() {
  useMetaPixel('1120568293740971');
  return <div className="w-full min-h-full bg-white text-ink-950" data-id="element-0" data-mp="31ctd9lpe1q60">
      <Hero data-id="element-1" data-mp="2wiyvwox99na3" />
      <main data-id="element-2" data-mp="2wiffjcn976y6">
        <PainPoints data-id="element-3" data-mp="2wip6p3k1bk5g" />
        <Solution data-id="element-4" data-mp="28ufpkexrnkkn" />
        <Tomos data-id="element-5" data-mp="28tw62tsgwo4i" />
        <Bonos data-id="element-6" data-mp="28tmifcuwat1z" />
        <Authorities data-id="element-7" data-mp="28t4k8aooa4rf" />
        <Pricing data-id="element-8" data-mp="28sbb5328r364" />
        <Guarantee data-id="element-9" data-mp="23vcjcr61v8b3" />
        <Faq data-id="element-10" data-mp="23vunsb2v8su3" />
        <FinalCta data-id="element-11" data-mp="23w4c7u89irxo" />
      </main>
      <SiteFooter data-id="element-12" data-mp="23v2s7099qv3t" />
    </div>;
}